import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Dropdown from '../FieldsComponents/Dropdown';
import { fetchDeptEmpJobwork, fetchJobworkMemo, insertEmpJobwork } from '../../Store/PHPSlice/Jobwork/jobworkApi';
import { selectDeptEmpJobwork, selectJobworkMemo } from '../Selectors/JobworkSelector/JobworkSelect';
import { Button, Grid, Paper, useMediaQuery, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { jobworkMenu } from '../TitleList';
import TitleBar from '../TitleBar';
import { getCurrentDate } from '../../Utils/Dateutils';
import axios from 'axios';
import { selectlocationdata } from '../Selectors/Master/ItemSelectors';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';


const EmpJobwork = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        fdt: '',
        todt: getCurrentDate(),
        departId: '',
        empId: '',
        jobMemo: '',
        totqty: '',
        totamt: '',
        gst: 0,
        gstAmt: '',
        tds: 0,
        tdsAmt: '',
        netAmt: '',
        advAmt: '',
        advAmt2: '',
        dedAmt: 0,
        finalAmt: '',
        userId: userdata?.ID,
        clothAmt: 0,
        firmId: '',
        locId: ''
    });
    const [jobwork, setJobwork] = useState([]);
    const [clothData, setClothData] = useState([]);
    const [extraAmt, setExtraAmt] = useState([]);
    const [firmdata, setFirmdata] = useState([]);
    const dispatch = useDispatch();
    const department = useSelector(selectDaparement);
    const jobMemo = useSelector(selectJobworkMemo);
    const deptEmpdata = useSelector(selectDeptEmpJobwork);
    const loclist = useSelector(selectlocationdata);

    useEffect(() => {
        dispatch(fetchDepartmentData());
        dispatch(fetchJobworkMemo());
        dispatch(fetchLocationData());
    }, []);

    useEffect(() => {
        if (jobMemo?.data?.memo) {
            const jobmemo = jobMemo?.data?.memo;
            setFormData(prev => ({
                ...prev,
                jobMemo: jobmemo
            }));
        }
    }, [jobMemo]);

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Vocher No.', name: 'jobMemo', type: 'readOnly' },
        { label: 'From Date', name: 'fdt', type: 'date' },
        { label: 'To Date', name: 'todt', type: 'date' },
    ];

    const handleDropdownChange = (e, dropdownType) => {
        const { value, name } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (name) {
            case 'departId':
                if (value) {
                    dispatch(fetchDeptEmpJobwork({ departId: value, locId: formData.locId }));
                }
                break;
            case 'locId':
                if (value) {
                    fetchFirmLocationwise(value);
                }
                break;
        }
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const isDesktop = useMediaQuery('(min-width:768px)');
    const dropdownlistfirst = [
        {
            label: 'Location',
            id: 'locId',
            options: loclist?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Firm',
            id: 'firmId',
            options: firmdata || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Department',
            id: 'departId',
            options: department?.data || [],
            value: formData.departId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'departId', value: newValue ? newValue.ID : '' } }, 'departId'),
            getOptionLabel: (option) => option.departNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Employee',
            id: 'empId',
            options: deptEmpdata?.data || [],
            value: formData.empId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'empId', value: newValue ? newValue.ID : '' } }, 'empId'),
            getOptionLabel: (option) => option.empNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const handleGetdata = () => {
        if (!formData.fdt) {
            // You can handle the error, maybe show an alert or message
            alert("Select From Date");
            return; // Prevent dispatching if fields are empty
        }
        if (!formData.todt) {
            // You can handle the error, maybe show an alert or message
            alert("Select To Date");
            return; // Prevent dispatching if fields are empty
        }
        if (!formData.departId) {
            // You can handle the error, maybe show an alert or message
            alert("Select Department");
            return; // Prevent dispatching if fields are empty
        }
        if (!formData.empId) {
            // You can handle the error, maybe show an alert or message
            alert("Select Employee.");
            return; // Prevent dispatching if fields are empty
        }

        const postdata = {
            fdt: formData.fdt,
            todt: formData.todt,
            empId: formData.empId,
            departId: formData.departId
        };
        fetchJobworkData(postdata);
    };


    const fetchJobworkData = async (id) => {
        const { fdt, todt, empId, departId } = id;
        try {
            const endpoint = `getJobwork_data&fdt=${fdt}&todt=${todt}&empId=${empId}&departId=${departId}`;
            const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
            const data = response.data;
            setClothData(data?.result);
            processJobworkData(data);
            console.log(data);
        } catch (error) {
            console.error('Error during GET request:', error);
        }
    };

    const fetchFirmLocationwise = async (id) => {
        try {
            const endpoint = `getLocationWise_Firms&locId=${id}`;
            const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
            const data = response.data;
            setFirmdata(data?.data);
            // console.log(data);
        } catch (error) {
            console.error('Error during GET request:', error);
        }
    };

    const processJobworkData = (jobdata) => {
        if (jobdata?.data?.length > 0) {

            // console.log(jobdata?.data);
            const convertdata = jobdata?.data?.map((val) => ({
                ID: parseFloat(val.ID),
                amt: parseFloat(val.amt),
                // departId: parseFloat(val.departId),
                // departNm: val.departNm,
                dt: val.dt,
                extra: val.extra,
                itemId: parseFloat(val.itemId),
                itemNm: val.itemNm,
                // piMemo: val.piMemo,
                rate: val.rate !== null ? parseFloat(val.rate) : 0,
                returnqty: parseFloat(val.reqty),
                balqty: parseFloat(val.balqty),
                stMemo: val.memo
            }));
            // console.log(convertdata);
            setJobwork(convertdata);
            // Calculate totals
            const totqty = jobdata?.data?.reduce((acc, val) => acc + parseFloat(val.reqty), 0);
            const totamt = jobdata?.data?.reduce((acc, val) => acc + parseFloat(val.amt), 0);
            const tdsamt = (totamt * parseFloat(formData.tds)) / 100;
            const gstamt = (totamt * parseFloat(formData.gst)) / 100;
            const netamt = totamt + gstamt + tdsamt;

            // Get advance amount and final amount
            const advamt = Array.isArray(jobdata?.advAmt)
                ? jobdata?.advAmt?.map((val) => ({
                    balamt: parseFloat(val.balamt),
                    bal: val.bal,
                    less: val.less,
                    paytype: val.paytype
                }))
                : [];
            // console.log(totqty)
            setExtraAmt(advamt);
            // const finalamt = netamt - advamt;

            const finalamt = netamt;

            // Update formData with calculated values
            setFormData(prev => ({
                ...prev,
                totqty: totqty,
                totamt: totamt,
                gstAmt: gstamt,
                tdsAmt: tdsamt,
                netAmt: netamt,
                finalAmt: finalamt
            }));
        } else {
            setJobwork(jobdata?.data);
            alert('Job is Not available');
        }
    };

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    const handleRateChange = (index, newRate) => {
        const updatedJobwork = [...jobwork];
        const updatedJob = updatedJobwork[index];

        const returnqty = updatedJob.returnqty;
        const extra = updatedJob.extra || 0;

        // Check if the value is not a number, is empty, null, or undefined
        if (isNaN(updatedJob.rate) || updatedJob.rate === "" || updatedJob.rate === null || updatedJob.rate === undefined) {
            updatedJob.rate = 0;// Assign 0 if the value is invalid
        }
        // Update rate and calculate the new amount
        updatedJob.rate = newRate;
        updatedJob.amt = newRate !== "" ? returnqty * (parseFloat(newRate) + parseFloat(extra)) : 0;

        // Update the jobwork
        setFormData(prevState => {
            const updatedTotamt = updatedJobwork.reduce((sum, job) => sum + parseFloat(job.amt || 0), 0);
            const updatedTotqty = updatedJobwork.reduce((sum, job) => sum + parseFloat(job.returnqty), 0);
            const updatedGstAmt = (updatedTotamt * parseFloat(formData.gst)) / 100;
            const updatedNetAmt = updatedTotamt + updatedGstAmt;
            const updatedfinalamt = updatedNetAmt - parseFloat(formData.dedAmt) - parseFloat(formData.clothAmt);
            return {
                ...prevState,
                totamt: Math.round(updatedTotamt * 100) / 100,  // Round to 2 decimal places
                totqty: Math.round(updatedTotqty * 100) / 100,
                gstAmt: Math.round(updatedGstAmt * 100) / 100,
                netAmt: Math.round(updatedNetAmt * 100) / 100,
                finalAmt: Math.round(updatedfinalamt * 100) / 100
            };
        });

        // Update the jobwork state
        setJobwork(updatedJobwork);
    };

    const handleExtraChange = (index, newExtra) => {
        const updatedJobwork = [...jobwork];
        const updatedJob = updatedJobwork[index];

        const returnqty = updatedJob.returnqty;
        const rate = updatedJob.rate || 0;

        // Check if the value is not a number, is empty, null, or undefined
        if (isNaN(updatedJob.extra) || updatedJob.extra === "" || updatedJob.extra === null || updatedJob.extra === undefined) {
            updatedJob.extra = 0;// Assign 0 if the value is invalid
        }

        // Update extra and calculate the new amount
        updatedJob.extra = newExtra;
        updatedJob.amt = newExtra !== "" ? returnqty * (parseFloat(rate) + parseFloat(newExtra)) : 0;

        // Update the jobwork
        setFormData(prevState => {
            const updatedTotamt = updatedJobwork.reduce((sum, job) => sum + parseFloat(job.amt || 0), 0);
            const updatedTotqty = updatedJobwork.reduce((sum, job) => sum + parseFloat(job.returnqty), 0);
            const updatedTdsAmt = (updatedTotamt * parseFloat(formData.tds)) / 100;
            const updatedGstAmt = (updatedTotamt * parseFloat(formData.gst)) / 100;
            const updatedNetAmt = updatedTotamt + updatedGstAmt + updatedTdsAmt;
            const updatedfinalamt = updatedNetAmt - parseFloat(formData.dedAmt) - parseFloat(formData.clothAmt);
            return {
                ...prevState,
                totamt: Math.round(updatedTotamt * 100) / 100,  // Round to 2 decimal places
                totqty: Math.round(updatedTotqty * 100) / 100,
                gstAmt: Math.round(updatedGstAmt * 100) / 100,
                netAmt: Math.round(updatedNetAmt * 100) / 100,
                finalAmt: Math.round(updatedfinalamt * 100) / 100,
                tdsAmt: Math.round(updatedTdsAmt)
            };
        });

        // Update the jobwork state
        setJobwork(updatedJobwork);
    };

    const handleGstChange = (newGst) => {
        let gstValue = parseFloat(newGst); // Use let instead of const

        // Check if the value is not a number, is empty, null, or undefined
        if (isNaN(gstValue) || newGst === "" || newGst === null || newGst === undefined) {
            gstValue = 0; // Assign 0 if the value is invalid
        }

        // Recalculate gstAmt based on new GST percentage
        const gstAmt = (formData.totamt * gstValue) / 100;

        // Update formData with the new GST value
        setFormData(prevState => ({
            ...prevState,
            gst: Math.round(gstValue),
            gstAmt: Math.round(gstAmt),
            netAmt: Math.round(prevState.totamt + prevState.tdsAmt + gstAmt),
            finalAmt: Math.round(prevState.totamt + prevState.tdsAmt + gstAmt - prevState.dedAmt - prevState.clothAmt)
        }));
    };


    const handleTDSChange = (newTds) => {
        let tdsValue = parseFloat(newTds); // Use let instead of const

        // Check if the value is not a number, is empty, null, or undefined
        if (isNaN(tdsValue) || newTds === "" || newTds === null || newTds === undefined) {
            tdsValue = 0; // Assign 0 if the value is invalid
        }

        // Recalculate gstAmt based on new GST percentage
        const tdsAmt = (formData.totamt * tdsValue) / 100;

        // Update formData with the new GST value
        setFormData(prevState => ({
            ...prevState,
            tds: Math.round(tdsValue),
            tdsAmt: Math.round(tdsAmt),
            netAmt: Math.round(prevState.totamt + prevState.gstAmt + tdsAmt),
            finalAmt: Math.round(prevState.totamt + tdsAmt + prevState.gstAmt - prevState.dedAmt - prevState.clothAmt)
        }));
    };

    function postObj(formData, jobwork, extraAmt, clothData) {
        const data = {
            dt: formData.dt,
            fdt: formData.fdt,
            todt: formData.todt,
            departId: formData.departId,
            empId: formData.empId,
            jobMemo: formData.jobMemo,
            totqty: parseFloat(formData.totqty),
            totamt: parseFloat(formData.totamt),
            gst: formData.gst,
            gstAmt: parseFloat(formData.gstAmt),
            netAmt: parseFloat(formData.netAmt),
            userId: formData.userId,
            jobwork: jobwork,
            deamt: parseFloat(formData.dedAmt),
            payableamt: parseFloat(formData.finalAmt),
            deductionAmt: extraAmt,
            clothData: clothData,
            tds: formData.tds,
            tdsAmt: parseFloat(formData.tdsAmt),
            clothAmt: parseFloat(formData.clothAmt),
            firmId: formData.firmId,
            locId: formData.locId
        };
        return data;
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        const finaldata = postObj(formData, jobwork, extraAmt, clothData);
        // console.log(finaldata);
        dispatch(insertEmpJobwork(finaldata))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Material Added");
                alert("Record Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    const handleAdvanceAmt = (e) => {
        const { value } = e.target;
        const advalue = parseFloat(value);
        if (advalue <= parseFloat(formData.advAmt2)) {
            const finalamt = value !== '' ? parseFloat(formData.netAmt) - parseFloat(value) : formData.netAmt;
            setFormData(prev => ({
                ...prev,
                advAmt: value,
                finalAmt: finalamt
            }));
        } else {
            alert(`Advance Amount is not greater than ${formData.advAmt2}`);
        }

    };

    const handleLessChange = (index, event) => {
        const value = parseFloat(event.target.value);

        if (isNaN(value)) {
            return; // Prevent invalid input (like letters)
        }

        const updatedExtraAmt = [...extraAmt];
        const item = updatedExtraAmt[index];

        // Check if the entered 'less' value is greater than 'balamt'
        if (value <= item.balamt) {
            item.less = value;
            item.bal = item.balamt - value;
            setExtraAmt(updatedExtraAmt);
        } else {
            // Optionally handle the case where less is greater than balamt
            alert('The less amount cannot be greater than the total balance amount');
        }

        const totsum = updatedExtraAmt?.reduce((acc, amt) => acc + parseFloat(amt?.less || 0), 0);
        const payableamt = parseFloat(formData.netAmt) - totsum;
        setFormData(prev => ({
            ...prev,
            finalAmt: Math.round(payableamt),
            dedAmt: Math.round(totsum)
        }));
    };

    const returnType = [
        { label: 'Carry Forward', value: 'carry' },
        { label: 'Return', value: 'return' },
        { label: 'Settlement', value: 'settlement' }
    ];

    const gstType = [
        { label: '3%', value: 3 },
        { label: '5%', value: 5 },
        { label: '12%', value: 12 },
        { label: '18%', value: 18 }
    ];

    const handleReturnTypeChange = (value, index, name) => {
        const updatedData = [...clothData];
        if (updatedData[index]) {
            updatedData[index][name] = value;
            setClothData(updatedData);
        }

    };

    const handleClothAmtChange = (index, value, name) => {
        const updatedData = [...clothData];
        if (updatedData[index]) {
            updatedData[index][name] = value;
            setClothData(updatedData);
        }
        const total = updatedData?.reduce((acc, item) => {
            const cloth = item || {};
            acc += parseFloat(cloth.m_amt || 0);
            acc += parseFloat(cloth.m1_amt || 0);
            acc += parseFloat(cloth.m2_amt || 0);
            acc += parseFloat(cloth.m3_amt || 0);
            return acc;
        }, 0) || 0;

        setFormData(prev => ({
            ...prev,
            clothAmt: Math.round(total),
            finalAmt: Math.round(prev.netAmt - total)
        }));

    };
    // console.log(clothData)

    return (
        <>
            <TitleBar data={jobworkMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Job Work Payment Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={1.2}>

                                {fields?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                <Grid item xs={12}>
                                    <Button variant="contained" color="primary" onClick={handleGetdata}>Get data</Button>
                                </Grid>



                                {jobwork?.length > 0 ?
                                    <>
                                        <Grid item xs={6}>
                                            <h3>Job Details</h3>
                                        </Grid>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableHead>
                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Date</TableCell>
                                                    {/* <TableCell sx={{ p:0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Department</TableCell> */}
                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Memo</TableCell>
                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Item</TableCell>
                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Total Qty.</TableCell>
                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Pending Qty.</TableCell>
                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Rate</TableCell>
                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Extra</TableCell>
                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Amount</TableCell>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        jobwork?.map((job, jobIndex) => (
                                                            <TableRow key={jobIndex}>
                                                                <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>{jobIndex + 1}</TableCell>
                                                                <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>{job.dt}</TableCell>
                                                                {/* <TableCell sx={{ p:0.3, border: '1px solid #000' }} align='center'>{job.departNm}</TableCell> */}
                                                                <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>{job.stMemo}</TableCell>
                                                                <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>{job.itemNm}</TableCell>
                                                                <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>{job.returnqty}</TableCell>
                                                                <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>{job.balqty}</TableCell>
                                                                <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>
                                                                    {/* {job.rate} */}

                                                                    <input type="text"
                                                                        value={job.rate}
                                                                        style={{ width: '100px', outline: 'none' }}
                                                                        placeholder='0'
                                                                        onChange={(e) => handleRateChange(jobIndex, e.target.value)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>
                                                                    {/* {job.extra} */}

                                                                    <input type="text"
                                                                        value={job.extra}
                                                                        style={{ width: '100px', outline: 'none' }}
                                                                        placeholder='0'
                                                                        onChange={(e) => handleExtraChange(jobIndex, e.target.value)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>{job.amt}</TableCell>
                                                            </TableRow>
                                                        ))
                                                    }

                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                            Total
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>{formData.totqty} </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'>{formData.totamt}</TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                            TDS
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>
                                                            <input type="text"
                                                                value={formData.tds}
                                                                style={{ width: '50px', outline: 'none' }}
                                                                onChange={(e) => handleTDSChange(e.target.value)}
                                                            />%
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'>{formData.tdsAmt} </TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                            GST
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>
                                                            {/* <input type="text"
                                                                value={formData.gst}
                                                                style={{ width: '50px', outline: 'none' }}
                                                                onChange={(e) => handleGstChange(e.target.value)}
                                                            />% */}


                                                            <select
                                                                value={formData.gst}
                                                                onChange={(e) => handleGstChange(e.target.value)}
                                                                style={{ padding: '2px', width: '50%' }}
                                                            >
                                                                <option value="">0</option>
                                                                {gstType?.map((type) => (
                                                                    <option key={type.value} value={type.value}>
                                                                        {type.label}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'>{formData.gstAmt} </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                            Net Amt
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'> {formData.netAmt}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                            Deduction Amt.
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                            {formData.dedAmt}
                                                        </TableCell>
                                                    </TableRow>


                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                            Cloth Amt.
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                            {formData.clothAmt}
                                                        </TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                            Payable Amt.
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'> </TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'> {formData.finalAmt}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </>
                                    : null
                                }



                                {
                                    extraAmt?.length > 0 &&
                                    <>
                                        <Grid item xs={6}>
                                            <h3>Deduction Details</h3>
                                        </Grid>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>

                                                <TableHead>
                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'> </TableCell>
                                                    {extraAmt?.map((item, index) => (
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row' key={index}>{item.paytype}</TableCell>
                                                    ))}
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Total</TableCell>
                                                        {extraAmt?.map((item, index) => (
                                                            <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' key={index}>{item.balamt}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Less</TableCell>
                                                        {extraAmt?.map((item, index) => (
                                                            <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' key={index}>
                                                                <input type="text" style={{ width: '100px' }} value={item.less}
                                                                    onChange={(event) => handleLessChange(index, event)}
                                                                />
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Balance</TableCell>
                                                        {extraAmt?.map((item, index) => (
                                                            <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' key={index}>
                                                                {item.bal}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableBody>

                                            </Table>
                                        </TableContainer>
                                    </>
                                }


                                {
                                    (clothData?.length > 0 && formData.departId === '9') ||
                                        (clothData?.length > 0 && formData.departId === '11') ?
                                        <>
                                            <Grid item xs={6}>
                                                <h3>Cloth Details</h3>
                                            </Grid>
                                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                                <Table>
                                                    <TableHead>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Memo</TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Cloth</TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Total Mtr.</TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Used Mtr.</TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Bal. Mtr.</TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>Return Type</TableCell>
                                                        <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center' className='tbl-row'>cloth Deduct Amt.</TableCell>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            clothData?.map((item, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>{item?.memo}</TableCell>
                                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>

                                                                        <span>{`main cloth - ${item?.mclothNm}`}</span>
                                                                        {item?.m1cloth !== "0" &&
                                                                            <span>
                                                                                <hr />
                                                                                {`m1  - ${item?.m1clothNm}`}
                                                                            </span>}
                                                                        {item?.m2cloth !== "0" && <span>
                                                                            <hr />
                                                                            {`m2  - ${item?.m2clothNm}`}
                                                                        </span>}
                                                                        {item?.m3cloth !== "0" && <span>
                                                                            <hr />
                                                                            {`m3  - ${item?.m3clothNm}`}
                                                                        </span>}

                                                                    </TableCell>

                                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>
                                                                        <span>{item?.mgmtr}</span>
                                                                        {item?.m1cloth !== "0" &&
                                                                            <span>
                                                                                <hr />
                                                                                {item?.m1gmtr}
                                                                            </span>}
                                                                        {item?.m2cloth !== "0" && <span>
                                                                            <hr />
                                                                            {item?.m2gmtr}
                                                                        </span>}
                                                                        {item?.m3cloth !== "0" && <span>
                                                                            <hr />
                                                                            {item?.m3gmtr}
                                                                        </span>}
                                                                    </TableCell>


                                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>
                                                                        <span>{item?.mused}</span>
                                                                        {item?.m1cloth !== "0" &&
                                                                            <span>
                                                                                <hr />
                                                                                {item?.m1used}
                                                                            </span>}
                                                                        {item?.m2cloth !== "0" && <span>
                                                                            <hr />
                                                                            {item?.m2used}
                                                                        </span>}
                                                                        {item?.m3cloth !== "0" && <span>
                                                                            <hr />
                                                                            {item?.m3used}
                                                                        </span>}
                                                                    </TableCell>

                                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>
                                                                        <span>{item?.final_mrem}</span>
                                                                        {item?.m1cloth !== "0" &&
                                                                            <span>
                                                                                <hr />
                                                                                {item?.final_m1rem}
                                                                            </span>}
                                                                        {item?.m2cloth !== "0" && <span>
                                                                            <hr />
                                                                            {item?.final_m2rem}
                                                                        </span>}
                                                                        {item?.m3cloth !== "0" && <span>
                                                                            <hr />
                                                                            {item?.final_m3rem}
                                                                        </span>}
                                                                    </TableCell>

                                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>
                                                                        <span>
                                                                            <select
                                                                                value={item?.m_type || ''}
                                                                                name='m_type'
                                                                                onChange={(e) => handleReturnTypeChange(e.target.value, index, e.target.name)}
                                                                                style={{ padding: '3px', width: '60%' }}
                                                                            >
                                                                                <option value="">Select</option>
                                                                                {returnType?.map((type) => (
                                                                                    <option key={type.value} value={type.value}>
                                                                                        {type.label}
                                                                                    </option>
                                                                                ))}
                                                                            </select>

                                                                        </span>

                                                                        {item?.m1cloth !== "0" &&
                                                                            <span>
                                                                                <hr />
                                                                                <select
                                                                                    value={item?.m1_type || ''}
                                                                                    name='m1_type'
                                                                                    onChange={(e) => handleReturnTypeChange(e.target.value, index, e.target.name)}
                                                                                    style={{ padding: '3px', width: '60%' }}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {returnType?.map((type) => (
                                                                                        <option key={type.value} value={type.value}>
                                                                                            {type.label}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>

                                                                            </span>}

                                                                        {item?.m2cloth !== "0" &&
                                                                            <span>
                                                                                <hr />
                                                                                <select
                                                                                    value={item?.m2_type || ''}
                                                                                    name='m2_type'
                                                                                    onChange={(e) => handleReturnTypeChange(e.target.value, index, e.target.name)}
                                                                                    style={{ padding: '3px', width: '60%' }}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {returnType?.map((type) => (
                                                                                        <option key={type.value} value={type.value}>
                                                                                            {type.label}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>

                                                                            </span>}

                                                                        {item?.m3cloth !== "0" &&
                                                                            <span>
                                                                                <hr />
                                                                                <select
                                                                                    value={item?.m3_type || ''}
                                                                                    name='m3_type'
                                                                                    onChange={(e) => handleReturnTypeChange(e.target.value, index, e.target.name)}
                                                                                    style={{ padding: '3px', width: '60%' }}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {returnType?.map((type) => (
                                                                                        <option key={type.value} value={type.value}>
                                                                                            {type.label}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>

                                                                            </span>}
                                                                    </TableCell>


                                                                    <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>
                                                                        <span>

                                                                            {
                                                                                item?.m_type === 'settlement' ?
                                                                                    <input type="text"
                                                                                        value={item?.m_amt}
                                                                                        name='m_amt'
                                                                                        style={{ width: '60px', outline: 'none' }}
                                                                                        placeholder='0'
                                                                                        onChange={(e) => handleClothAmtChange(index, e.target.value, e.target.name)}
                                                                                    />
                                                                                    : null
                                                                            }
                                                                        </span>

                                                                        {item?.m1cloth !== "0" &&
                                                                            <span>
                                                                                <hr />

                                                                                {
                                                                                    item?.m1_type === 'settlement' ?
                                                                                        <input type="text"
                                                                                            value={item?.m1_amt}
                                                                                            name='m1_amt'
                                                                                            style={{ width: '60px', outline: 'none' }}
                                                                                            placeholder='0'
                                                                                            onChange={(e) => handleClothAmtChange(index, e.target.value, e.target.name)}
                                                                                        />
                                                                                        : null
                                                                                }
                                                                            </span>}

                                                                        {item?.m2cloth !== "0" &&
                                                                            <span>
                                                                                <hr />

                                                                                {
                                                                                    item?.m2_type === 'settlement' ?
                                                                                        <input type="text"
                                                                                            value={item?.m2_amt}
                                                                                            name='m2_amt'
                                                                                            style={{ width: '60px', outline: 'none' }}
                                                                                            placeholder='0'
                                                                                            onChange={(e) => handleClothAmtChange(index, e.target.value, e.target.name)}
                                                                                        />
                                                                                        : null
                                                                                }
                                                                            </span>}

                                                                        {item?.m3cloth !== "0" &&
                                                                            <span>
                                                                                <hr />

                                                                                {
                                                                                    item?.m3_type === 'settlement' ?
                                                                                        <input type="text"
                                                                                            value={item?.m3_amt}
                                                                                            name='m3_amt'
                                                                                            style={{ width: '60px', outline: 'none' }}
                                                                                            placeholder='0'
                                                                                            onChange={(e) => handleClothAmtChange(index, e.target.value, e.target.name)}
                                                                                        />
                                                                                        : null
                                                                                }
                                                                            </span>}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        }
                                                        <TableRow>
                                                            <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'></TableCell>
                                                            <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'></TableCell>
                                                            <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'></TableCell>
                                                            <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'></TableCell>
                                                            <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'></TableCell>
                                                            <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'></TableCell>
                                                            <TableCell sx={{ p: 0.3, border: '1px solid #000', fontWeight: 'bold' }} align='center'>Total</TableCell>
                                                            <TableCell sx={{ p: 0.3, border: '1px solid #000' }} align='center'>{formData.clothAmt}</TableCell>

                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </>
                                        : null
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default EmpJobwork;
